module.exports = __webpack_public_path__ + "img/SYDA.41fe2e74.png";